import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import TemplateIcon from '@atlaskit/icon-lab/core/template';

import { Ati } from '@atlassian/ari';

import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';
import type { TemplateModalProps } from '@confluence/experiment-cfind-5291-template-touchpoint/entry-points/TemplateModal.ts';
import { TemplateModal } from '@confluence/experiment-cfind-5291-template-touchpoint/entry-points/TemplateModal.ts';
import type { UseMenuItemProps, UseMenuItemReturnProps } from './index.tsx';

export const messages = defineMessages({
	title: {
		id: 'create-blank-fabric-page.universal-create.start-from-template.title',
		defaultMessage: 'Start from template',
		description: 'title indicating that this option will open a template picker modal',
	},
});

export function useStartFromTemplateItem({
	onClick,
	spaceKey,
	parentId,
}: UseMenuItemProps): UseMenuItemReturnProps {
	const { formatMessage } = useIntl();
	const { showModal } = useDialogs();

	const handleClick = useCallback(
		(_e: React.MouseEvent | React.KeyboardEvent) => {
			onClick('startFromTemplatePopoverItem');
			showModal<TemplateModalProps>(TemplateModal, {
				spaceKey,
				parentId,
				testId: 'start-from-template-modal',
			});
		},
		[onClick, showModal, spaceKey, parentId],
	);

	return {
		ati: Ati.parse('ati:cloud:confluence:template'),
		children: formatMessage(messages.title),
		onClick: handleClick,
		elemBefore: TemplateIcon,
		testId: 'create-menu-start-from-template-item',
	};
}
